import type { Me } from "@fistos/shared/api";
import { HandFist } from "lucide-solid";
import { createResource, Match, onCleanup, Switch, type ParentProps } from "solid-js";
import { Shell } from "@/components/Shell";
import { api, ApiError, setUnauthorizedHandler } from "@/lib/api";
import { connectLive, disconnectLive } from "@/lib/live";
import { LoginPage } from "@/pages/Login";

async function loadMe(): Promise<Me | null> {
  try {
    return await api.me();
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) return null;
    throw e;
  }
}

export function App(props: ParentProps) {
  const [me, { mutate }] = createResource(loadMe);
  const signedOut = () => {
    disconnectLive();
    mutate(null);
  };
  setUnauthorizedHandler(signedOut);
  onCleanup(disconnectLive);

  return (
    <Switch>
      <Match when={me.error}>
        <div class="text-muted-foreground flex min-h-screen items-center justify-center p-6 text-sm">
          Cannot reach the FistOS server. Reload to try again.
        </div>
      </Match>
      <Match when={me.loading}>
        <div class="flex min-h-screen items-center justify-center">
          <HandFist class="text-muted-foreground size-8 animate-pulse" />
        </div>
      </Match>
      <Match when={me() === null}>
        <LoginPage />
      </Match>
      <Match when={me()}>
        {(user) => {
          connectLive();
          return (
            <Shell user={user()} onSignedOut={signedOut}>
              {props.children}
            </Shell>
          );
        }}
      </Match>
    </Switch>
  );
}
